<template>
  <v-card>
    <div class="image-frame d-flex align-center justify-center" style="aspect-ratio: 16/10; max-height: 320px;">
      <img
        v-if="preview !== ''"
        :src="preview"
        :style="{ aspectRatio: `${dimensions?.width}/${dimensions?.height}`, maxHeight: '100%' }"
      >
      <span
        v-else
        class="d-flex justify-center align-center bg-grey-lighten-3 flex-grow-1"
        :style="{ aspectRatio: `${dimensions?.width}/${dimensions?.height}`, maxHeight: '100%' }"
      >
        <v-icon size="72" color="primary">fa-solid fa-image</v-icon>
      </span>
    </div>
    <v-card-title>{{ props.label }}</v-card-title>
    <v-card-text v-if="props.description">
      {{ props.description }}
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        icon="fa-solid fa-plus"
        :disabled="props.disabled"
        @click="input?.click()"
      />
      <v-btn
        color="red"
        icon="fa-solid fa-trash"
        :disabled="props.disabled"
        @click="clear"
      />
      <v-spacer />
      <v-chip v-if="props.dimensions" color="primary">
        {{ props.dimensions.width }}x{{ props.dimensions.height }}
      </v-chip>
    </v-card-actions>
    <v-file-input
      ref="input"
      v-model="image"
      :label="props.label"
      :accept="['image/jpeg', 'image/png', 'image/webp']"
      prepend-icon=""
      clear-icon=""
      :clearable="false"
      :show-size="1000"
      hide-input
      @change="onChanged"
    />
  </v-card>
</template>

<script lang="ts" setup>
import { computed, ref, useTemplateRef, watchEffect } from 'vue'

const props = defineProps<{
  modelValue: File | undefined
  label: string
  description?: string
  maxSize?: number
  aspectRatio?: string
  dimensions?: { width: number, height: number }
  disabled?: boolean
  previewUrl?: string
}>()

const input = useTemplateRef('input')

const emit = defineEmits<{
  'update:modelValue': [File | undefined]
}>()

const image = ref<File | undefined>(props.modelValue)

const preview = computed(() => {
  if (image.value) return URL.createObjectURL(image.value)
  return props.previewUrl ?? ''
})

function onChanged() {
  emit('update:modelValue', image.value)
}

function clear() {
  if (image.value === undefined && !props.previewUrl) return
  image.value = undefined
  onChanged()
}

watchEffect(() => {
  if (props.modelValue) {
    image.value = props.modelValue
  }
})
</script>
